// ----------- ACTION NAMES

// set list edit state is for setting the toggle field listEditState.

export const SPOTTING_GROUP_SET_LIST_EDIT_STATE = 'SPOTTING_GROUP_SET_LIST_EDIT_STATE';
export const SPOTTING_GROUP_SET_TERM_IDS = 'SPOTTING_GROUP_SET_TERM_IDS';
export const SPOTTING_GROUP_SET_CURRENT_TERM_NAME = 'SPOTTING_GROUP_SET_CURRENT_TERM_NAME';
export const SPOTTING_GROUP_SET_CURRENT_TERM = 'SPOTTING_GROUP_SET_CURRENT_TERM';
export const SPOTTING_GROUP_SET_CURRENT_TERM_WORDS = 'SPOTTING_GROUP_SET_CURRENT_TERM_WORDS';
export const SPOTTING_GROUP_EDITING_SET_EDIT_WORDS = 'SPOTTING_GROUP_EDITING_SET_EDIT_WORDS';
export const SPOTTING_GROUP_EDITING_SET_EDIT_WORDS_CHECKLIST = 'SPOTTING_GROUP_EDITING_SET_EDIT_WORDS_CHECKLIST';
export const SPOTTING_GROUP_SET_EDITING_TERM_NAME = 'SPOTTING_GROUP_SET_EDITING_TERM_NAME';

export const SPOTTING_GROUP_SET_LIST_STATE = 'SPOTTING_GROUP_SET_LIST_STATE';
export const SPOTTING_GROUP_SET_LIST_STATE_NOT_LOADED = 'SPOTTING_GROUP_SET_LIST_STATE_NOT_LOADED';
export const SPOTTING_GROUP_SET_LIST_STATE_LOADING = 'SPOTTING_GROUP_SET_LIST_STATE_LOADING';
export const SPOTTING_GROUP_SET_LIST_STATE_LOADED = 'SPOTTING_GROUP_SET_LIST_STATE_LOADED';
export const SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR = 'SPOTTING_GROUP_SET_LIST_STATE_LOAD_ERROR';
export const SPOTTING_GROUP_SET_CLEAR_FLAG = 'SPOTTING_GROUP_SET_CLEAR_FLAG';

export const SPOTTING_GROUP_SET_EDITING_STATE = 'SPOTTING_GROUP_SET_EDITING_STATE';
export const SPOTTING_GROUP_SET_EDITING_STATE_NOT_LOADED = 'SPOTTING_GROUP_SET_EDITING_STATE_NOT_LOADED';
export const SPOTTING_GROUP_SET_EDITING_STATE_LOADING = 'SPOTTING_GROUP_SET_EDITING_STATE_LOADING';
export const SPOTTING_GROUP_SET_EDITING_STATE_LOADED = 'SPOTTING_GROUP_SET_EDITING_STATE_LOADED';
export const SPOTTING_GROUP_SET_EDITING_STATE_LOAD_ERROR = 'SPOTTING_GROUP_SET_EDITING_STATE_LOAD_ERROR';

export const SPOTTING_GROUP_START_ADDING_GROUP = 'SPOTTING_GROUP_START_ADDING_GROUP';
export const SPOTTING_GROUP_SAVE_ADDING_GROUP = 'SPOTTING_GROUP_SAVE_ADDING_GROUP';
export const SPOTTING_GROUP_STOP_ADDING_GROUP = 'SPOTTING_GROUP_STOP_ADDING_GROUP';

export const SPOTTING_GROUP_SET_NEW_GROUP_NAME = 'SPOTTING_GROUP_SET_NEW_GROUP_NAME';
export const SPOTTING_GROUP_SET_NEW_GROUP_TERMS = 'SPOTTING_GROUP_SET_NEW_GROUP_TERMS';
export const SPOTTING_GROUP_SET_NEW_GROUP_WEIGHT = 'SPOTTING_GROUP_SET_NEW_GROUP_WEIGHT';

export const SPOTTING_GROUP_SET_ADDING_STATE = 'SPOTTING_GROUP_SET_ADDING_STATE';
export const SPOTTING_GROUP_SET_TAB_KEY = 'SPOTTING_GROUP_SET_TAB_KEY';
export const SPOTTING_GROUP_ADD_NEW_GROUP = 'SPOTTING_GROUP_ADD_NEW_GROUP';
export const SPOTTING_GROUP_DELETE_CHECKED_LISTS = 'SPOTTING_GROUP_DELETE_CHECKED_LISTS';

export const SPOTTING_GROUP_DELETE_ONE = 'SPOTTING_GROUP_DELETE_ONE';
export const SPOTTING_GROUP_DOWNLOAD_GROUP = 'SPOTTING_GROUP_DOWNLOAD_GROUP';

// ----- state values not action names

export const SPOTTING_GROUP_LIST_STATE_NOT_LOADED = 'SPOTTING_GROUP_LIST_STATE_NOT_LOADED';
export const SPOTTING_GROUP_LIST_STATE_LOADING = 'SPOTTING_GROUP_LIST_STATE_LOADING';
export const SPOTTING_GROUP_LIST_STATE_LOADED = 'SPOTTING_GROUP_LIST_STATE_LOADED';
export const SPOTTING_GROUP_LIST_STATE_ERROR = 'SPOTTING_GROUP_LIST_STATE_ERROR';

export const SPOTTING_GROUP_EDITING_STATE_NOT_LOADED = 'SPOTTING_GROUP_EDITING_STATE_NOT_LOADED';
export const SPOTTING_GROUP_EDITING_STATE_LOADING = 'SPOTTING_GROUP_EDITING_STATE_LOADING';
export const SPOTTING_GROUP_EDITING_STATE_LOADED = 'SPOTTING_GROUP_EDITING_STATE_LOADED';
export const SPOTTING_GROUP_EDITING_STATE_ERROR = 'SPOTTING_GROUP_EDITING_STATE_ERROR';

export const SPOTTING_GROUP_ADDING_STATE_NOT_ADDING_GROUP = 'SPOTTING_GROUP_ADDING_STATE_NOT_ADDING_GROUP';
export const SPOTTING_GROUP_ADDING_STATE_ADDING_GROUP = 'SPOTTING_GROUP_ADDING_STATE_ADDING_GROUP';
export const SPOTTING_GROUP_ADDING_STATE_SAVING_GROUP = 'SPOTTING_GROUP_ADDING_STATE_SAVING_GROUP';
export const SPOTTING_GROUP_ADDING_GROUP_RESET = 'SPOTTING_GROUP_ADDING_GROUP_RESET';

// ----- term search

export const SPOTTING_GROUP_EDITING_SET_SEARCH_TERM = 'SPOTTING_GROUP_EDITING_SET_SEARCH_TERM';

// SAGA NAMES

export const SPOTTING_GROUP_FETCH_TERMS = 'SPOTTING_GROUP_FETCH_TERMS';
